'use client'

import React from 'react'

type Props = {
    ph: number
}

const WIDTH = 340
const HEIGHT = 70
const PAD = 14
const BAR_HEIGHT = 22
const BAR_Y = 22

export default function PhScaleChart({ ph }: Props) {
    const clamped = Math.min(Math.max(ph, 0), 14)
    const plotWidth = WIDTH - PAD * 2
    const markerX = PAD + (clamped / 14) * plotWidth

    const gradientId = 'ph-scale-gradient'

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#dc2626" />
                    <stop offset="50%" stopColor="#16a34a" />
                    <stop offset="100%" stopColor="#2563eb" />
                </linearGradient>
            </defs>
            <rect x={PAD} y={BAR_Y} width={plotWidth} height={BAR_HEIGHT} rx={4} fill={`url(#${gradientId})`} />
            {Array.from({ length: 15 }, (_, i) => i).map((tick) => {
                const x = PAD + (tick / 14) * plotWidth
                return (
                    <g key={tick}>
                        <line x1={x} y1={BAR_Y + BAR_HEIGHT} x2={x} y2={BAR_Y + BAR_HEIGHT + 4} stroke="#9ca3af" strokeWidth={1} />
                        <text x={x} y={BAR_Y + BAR_HEIGHT + 15} fontSize={8} textAnchor="middle" fill="#9ca3af">{tick}</text>
                    </g>
                )
            })}
            {/* marker */}
            <polygon points={`${markerX - 5},${BAR_Y - 8} ${markerX + 5},${BAR_Y - 8} ${markerX},${BAR_Y - 1}`} fill="#111827" />
            <text x={markerX} y={BAR_Y - 11} fontSize={11} textAnchor="middle" fill="#111827" fontWeight={700}>
                {clamped.toFixed(1)}
            </text>
        </svg>
    )
}
